import { useMemo } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { stripLocale } from "@/i18n/locale";
import { LocaleProvider } from "@/i18n/LocaleContext";
import Home from "@/pages/home";
import About from "@/pages/about";
import Contact from "@/pages/contact";
import AxleRepair from "@/pages/services/axle-repair";
import EmergencySameDayTrailerRepair from "@/pages/services/emergency-same-day-trailer-repair";
import Reviews from "@/pages/reviews";
import TrailerAxleReplacementCost from "@/pages/trailer-axle-replacement-cost";
import Free51PointInspection from "@/pages/free-51-point-inspection";
import ProductsIndex from "@/pages/products/index";
import Hubs from "@/pages/products/hubs";
import Suspension from "@/pages/products/suspension-parts";
import JacksCouplers from "@/pages/products/jacks-couplers";
import TiresWheels from "@/pages/products/tires-wheels";
import Dexter from "@/pages/dexter";
import AxleOrderForms from "@/pages/axle-order-forms";
import Rebates from "@/pages/rebates";
import AxleRebate from "@/pages/rebates/axle-rebate";
import BlogIndex from "@/pages/blog/index";
import BlogPost from "@/pages/blog/post";
import LocationsIndex from "@/pages/locations/index";
import CityPage from "@/pages/locations/city";
import CityProductPage from "@/pages/locations/city-product";
import Invite from "@/pages/invite";
import NotFound from "@/pages/not-found";

/**
 * One route table serves both languages. Routes match against the pathname
 * with the /es prefix removed, while useLocation() (and LocaleProvider) still
 * see the real URL. Because English and Spanish URLs resolve to the very same
 * element tree, switching language keeps component instances mounted, so
 * in-progress form drafts and other local state survive the switch.
 */
function LocalizedRoutes() {
  const location = useLocation();
  const matchLocation = useMemo(
    () => ({ ...location, pathname: stripLocale(location.pathname) }),
    [location],
  );
  return (
    <Routes location={matchLocation}>
<Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/about/" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/contact/" element={<Contact />} />
      <Route path="/services/axle-repair" element={<AxleRepair />} />
      <Route path="/services/axle-repair/" element={<AxleRepair />} />
      <Route path="/services/emergency-same-day-trailer-repair" element={<EmergencySameDayTrailerRepair />} />
      <Route path="/services/emergency-same-day-trailer-repair/" element={<EmergencySameDayTrailerRepair />} />
      <Route path="/reviews" element={<Reviews />} />
      <Route path="/reviews/" element={<Reviews />} />
      <Route path="/trailer-axle-replacement-cost" element={<TrailerAxleReplacementCost />} />
      <Route path="/trailer-axle-replacement-cost/" element={<TrailerAxleReplacementCost />} />
      <Route path="/free-51-point-inspection" element={<Free51PointInspection />} />
      <Route path="/free-51-point-inspection/" element={<Free51PointInspection />} />
      <Route path="/products" element={<ProductsIndex />} />
      <Route path="/products/" element={<ProductsIndex />} />
      <Route path="/products/hubs" element={<Hubs />} />
      <Route path="/products/hubs/" element={<Hubs />} />
      <Route path="/products/suspension-parts" element={<Suspension />} />
      <Route path="/products/suspension-parts/" element={<Suspension />} />
      <Route path="/products/jacks-couplers" element={<JacksCouplers />} />
      <Route path="/products/jacks-couplers/" element={<JacksCouplers />} />
      <Route path="/products/tires-wheels" element={<TiresWheels />} />
      <Route path="/products/tires-wheels/" element={<TiresWheels />} />
      <Route path="/dexter" element={<Dexter />} />
      <Route path="/dexter/" element={<Dexter />} />
      <Route path="/axle-order-forms" element={<AxleOrderForms />} />
      <Route path="/axle-order-forms/" element={<AxleOrderForms />} />
      <Route path="/rebates" element={<Rebates />} />
      <Route path="/rebates/" element={<Rebates />} />
      <Route path="/rebates/axle-rebate" element={<AxleRebate />} />
      <Route path="/rebates/axle-rebate/" element={<AxleRebate />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/blog/:slug/" element={<BlogPost />} />
      <Route path="/locations" element={<LocationsIndex />} />
      <Route path="/locations/" element={<LocationsIndex />} />
      <Route path="/locations/:slug" element={<CityPage />} />
      <Route path="/locations/:slug/" element={<CityPage />} />
      <Route path="/locations/:slug/:product" element={<CityProductPage />} />
      <Route path="/locations/:slug/:product/" element={<CityProductPage />} />
      <Route path="/invite" element={<Invite />} />
      <Route path="/invite/" element={<Invite />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function AppRoutes() {
  return (
    <LocaleProvider>
      <LocalizedRoutes />
    </LocaleProvider>
  );
}
